<template>
    <div class="padding-vertical-content mb-3 mb-lg-4">
        <div>
            <ValidationObserver ref="observer">
                <div class="mb-5">
                    <div>
                        <label class="mb-4 h4 text-uppercase">Resumen de compra</label>
                        <div>
                            <ResumenCompraComponent
                                :base="base"
                                :categoria = "base.categoria_base"
                                :esMovil="esMovil"
                                :indumentariasElegidas="base.categoria_base.indumentariasElegidas"
                                @setTotal="(importe_total) => { total = importe_total }"
                            />
                            <div class="form-group">
                                <label for="metodo_pago">Método de pago</label>
                                <ValidationProvider name="metodo_pago" rules="required" v-slot="{ errors }">
                                    <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" name="metodo_pago" id="metodo_pago" v-model="localData.metodo_pago">
                                        <template v-for="(metodo, index) in metodos_pago">
                                            <option :key="index" :value="metodo.id">{{ metodo.nombre }}</option>
                                        </template>
                                    </select>
                                </ValidationProvider>
                            </div>
                            <PaymentCalculator :amountDue="total" :key="`payment-calc-${total}`" v-if="localData.metodo_pago == 1" />
                        </div>
                        <div class="mt-3">
                            <div v-if="!compra_finalizada" class="col-12 text-right mt-4">
                                <button type="button" @click="volver" name="button" :class="!esMovil ? 'button effect-button large-button mr-2' : 'button effect-button mr-2'" id="volver-paso-1">
                                    <span>{{ $t('formularios.atras') }}</span>
                                </button>
                                <button @click="submit()" type="submit" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" id="terminar-paso-2">
                                    <span>{{$t('bases.terminar')}}</span>
                                </button>
                            </div>
                            <div v-if="!loading">
                                <div class="col-12 mt-3" v-if="compra_finalizada">
                                    <div class="alert alert-success alert-dismissible">
                                        <h5><i class="icon fas fa-check"></i>¡Compra finalizada correctamente!</h5>
                                        <template>
                                            <Button @click="$router.push({ name: 'back.bases.index', params: { lista_id: lista_id } })">Volver al listado de bases</Button>
                                        </template>
                                    </div>
                                </div>
                                <div v-if="errors.length > 0">
                                    <div class="alert alert-danger alert-dismissible">
                                        <h5><i class="icon fas fa-ban"></i>Ha ocurrido un error</h5>
                                        <template>
                                            <Button @click="$router.push({ name: 'back.bases.index', params: { lista_id: lista_id } })">Volver al listado de bases</Button>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <LoaderComponent/>
                            </div>
                        </div>
                    </div>
                </div>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
    import ResumenCompraComponent from "./ResumenCompraComponent";
    import PaymentCalculator from '@/components/common/PaymentCalculator';

    export default {
        props: ["base", "items", "esMovil"],
        data() {
            return {
                loading: false,
                show: true,
                compra_finalizada: false,
                errors: [],
                total: null,
                localData: { ...this.base }
            };
        },
        computed: {
            metodos_pago() {
                return this.teatro.metodos_pago_abonos_bases.filter(metodo_pago => metodo_pago.show_taquilla == 1);
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            lista_id() {
                return this.$route.params.lista_id;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    this.crearBase();
                }
            },
            atras() {
                this.$emit('volver');
            },
            crearBase() {
                this.loading = true;

                const params = {
                    metodo_pago: this.localData.metodo_pago,
                    categoria_base_id: this.base.categoria_base_id,
                    lista_id: this.lista_id,
                    session_id: this.base.categoria_base.session_id
                }
                this.$store.dispatch(
                    this.config.getVuexAlias("back.bases.crear"), params).then(res => {
                    this.compra_finalizada = true;
                    this.show = false;
                    this.$emit("terminado", this.localData);
                }).catch(error => {
                    this.show = true;
                    this.compra_finalizada = false;
                    this.errors = error.response.data;
                }).finally(() => {
                    this.loading = false;
                });
            },
            borrarMetodoDePago(metodos_de_pago, id) {
                const metodo_pago_id = metodos_de_pago.findIndex(metodo_de_pago => metodo_de_pago.id === id);
                metodos_de_pago.splice(metodo_pago_id, 1);
                return metodos_de_pago;
            },
            volver() {
                this.$emit('volver');
            }
        },
        components: {
            ResumenCompraComponent, PaymentCalculator
        },
    };
</script>
